// eslint-disable-next-line import/prefer-default-export
export const getImageSize = (width) => {
  const selectedSize = [160, 400, 800, 1500].find((size) => size / width >= 2);
  return selectedSize ? `image${selectedSize}pxUrl` : 'imageOriginalUrl';
};
